const useCases = [
  {
    icon: 'ri-megaphone-line',
    area: 'Для маркетинга',
    title: 'Персональные видео на лендингах',
    text: 'Персональные видео-приветствия на лендингах и квизах, которые повышают конверсию в заявку на 10–30%.',
    metric: '+10–30%',
    metricLabel: 'конверсии',
  },
  {
    icon: 'ri-customer-service-2-line',
    area: 'Для отделов продаж',
    title: 'Видео в холодных рассылках',
    text: 'Личные видео-сообщения для «холодных» рассылок. Это повышает количество ответов от клиентов на 30–40%.',
    metric: '+30–40%',
    metricLabel: 'ответов',
  },
  {
    icon: 'ri-book-open-line',
    area: 'Для обучения (HR)',
    title: 'Обучающие курсы и инструкции',
    text: 'Быстрое создание видео-инструкций для сотрудников и обучающих курсов для клиентов без найма видеостудий.',
    metric: '0 студий',
    metricLabel: 'не нужно',
  },
  {
    icon: 'ri-customer-service-line',
    area: 'Для сервиса',
    title: 'Видео-ответы на частые вопросы',
    text: 'Видео-ответы на Топ-10 частых вопросов (FAQ), что разгружает техподдержку и повышает лояльность.',
    metric: 'Топ-10',
    metricLabel: 'FAQ закрыты',
  },
];

export default function AIAvatarUseCases() {
  return (
    <section className="py-14 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-money-cny-circle-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Применение и монетизация
            </span>
          </div>
          <h2 className="text-xl sm:text-4xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Где ваш аватар будет приносить прибыль?
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
          {useCases.map((uc) => (
            <div key={uc.title} className="relative bg-[#F9F5EF] rounded-2xl p-5 sm:p-8 border border-[#E8DDD0] hover:border-[#C5A880] transition-colors duration-300 overflow-hidden">

              <div className="flex items-start gap-3 sm:gap-4 mb-4">
                <div className="w-11 h-11 sm:w-12 sm:h-12 flex items-center justify-center rounded-xl bg-[#1A2B4C] flex-shrink-0">
                  <i className={`${uc.icon} text-lg sm:text-xl text-[#C5A880]`}></i>
                </div>
                <div>
                  <span className="text-xs text-[#C5A880] font-bold font-['Montserrat'] uppercase tracking-wider">
                    {uc.area}
                  </span>
                  <h3 className="text-sm sm:text-lg font-bold text-[#1A2B4C] font-['Playfair_Display'] leading-snug">
                    {uc.title}
                  </h3>
                </div>
              </div>

              <p className="text-gray-600 text-sm leading-relaxed font-['Montserrat'] mb-4 sm:mb-5 text-justify">
                {uc.text}
              </p>

              <div className="inline-flex items-center gap-2 bg-[#1A2B4C]/08 px-3 sm:px-4 py-2 rounded-full">
                <i className="ri-bar-chart-2-line text-[#C5A880] text-sm"></i>
                <span className="text-[#1A2B4C] font-bold text-sm font-['Montserrat']">{uc.metric}</span>
                <span className="text-gray-500 text-xs font-['Montserrat']">{uc.metricLabel}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
